import { createContext, useContext } from "react";

export interface VsmCatalogItem {
  readonly id: string;
  readonly name: string;
}

export interface VsmCatalog {
  readonly vsms: readonly VsmCatalogItem[];
  /** True on VSM Home, where the subject VSM is fixed by the dashboard. */
  readonly scopeLocked?: boolean;
  readonly isLoading?: boolean;
  readonly isLoadingMore?: boolean;
  readonly error?: string | null;
  readonly hasMore?: boolean;
  readonly searchQuery?: string;
  readonly activate?: (selectedIds: readonly string[]) => void;
  readonly onSearchChange?: (query: string) => void;
  readonly onLoadMore?: () => void;
  readonly onRetry?: () => void;
}

const Ctx = createContext<VsmCatalog | null>(null);

export const VsmCatalogProvider = Ctx.Provider;

export function useVsmCatalog(): VsmCatalog | null {
  return useContext(Ctx);
}
